// components/Sender/SenderSettingsTab.js
import React, { useState } from "react";
import { SenderApi, TOKEN_KEY } from "./SenderApi";

export function SenderSettingsTab({ settings, setSettings, add }) {
  const [draft, setDraft] = useState(() => {
    let tok = "";
    try { tok = localStorage.getItem(TOKEN_KEY) || ""; } catch { /* */ }
    return { token: tok };
  });
  const [test, setTest] = useState(null);
  const [testing, setTesting] = useState(false);

  const save = () => {
    try {
      localStorage.setItem(TOKEN_KEY, draft.token || "");
      setSettings?.({ token: draft.token || "" });
      add?.("💾 Токен сохранён в localStorage[" + TOKEN_KEY + "]", "success");
    } catch (e) {
      add?.("Ошибка: " + e.message, "error");
    }
  };

  const clearToken = () => {
    try { localStorage.removeItem(TOKEN_KEY); } catch { /* */ }
    setDraft({ token: "" });
    setSettings?.({ token: "" });
    add?.("🗑 Токен удалён из localStorage", "info");
  };

  const runTest = async () => {
    setTesting(true);
    setTest(null);
    const sentAuth = !!localStorage.getItem(TOKEN_KEY);

    const url = `${SenderApi.globalOutreachBase}/worker/filter-options/`;
    try {
      const data = await SenderApi.filterOptions({});
      const looksLikeCounts =
        data && typeof data === "object" && data.counts && typeof data.counts === "object";
      setTest({
        ok: true,
        sentAuth,
        url,
        dataIsNull: data === null,
        dataKeys: data && typeof data === "object" ? Object.keys(data) : [],
        looksLikeCounts,
        total: data?.counts?.total,
        sample: data,
        at: new Date().toLocaleTimeString("ru-RU"),
      });
      if (data === null) {
        add?.("⚠️ Сервер вернул 200, но тело пустое — see Network tab", "warn");
      } else if (!looksLikeCounts) {
        add?.("⚠️ Ответ пришёл, но не в формате {counts:{...}}", "warn");
      } else {
        add?.("✅ Подключение к outreach OK", "success");
      }
    } catch (e) {
      setTest({
        ok: false,
        sentAuth,
        url,
        error: e.message,
        at: new Date().toLocaleTimeString("ru-RU"),
      });
      add?.("❌ Тест провалился: " + e.message, "error");
    } finally {
      setTesting(false);
    }
  };

  let currentToken = null;
  try { currentToken = localStorage.getItem(TOKEN_KEY); } catch { /* */ }

  return (
    <div className="section-card">
      <h3 style={{ marginTop: 0 }}>⚙️ Настройки</h3>

      <div style={box}>
        <div style={{ fontWeight: 700, marginBottom: 10 }}>
          Bearer Token (глобальный outreach)
        </div>
        <input className="form-input" type="password"
               placeholder="FSEBDHUVTB..."
               value={draft.token || ""}
               onChange={(e) => setDraft({ ...draft, token: e.target.value })} />
        <div style={{ fontSize: 11, color: "#9ca3af", marginTop: 6 }}>
          Сохраняется в <code>localStorage["{TOKEN_KEY}"]</code> по кнопке 💾.
        </div>
        <div style={{
          fontSize: 11, color: "#6b7280", marginTop: 6,
          fontFamily: "Consolas, monospace",
          background: "#fff", padding: "6px 8px", borderRadius: 6,
          border: "1px solid #e5e7eb", wordBreak: "break-all",
        }}>
          localStorage["{TOKEN_KEY}"] =&nbsp;
          {!currentToken ? (
            <span style={{ color: "#dc2626" }}>null (нет)</span>
          ) : (
            <span style={{ color: "#16a34a" }}>
              {currentToken.slice(0, 8)}…{currentToken.slice(-4)}
              {" "}({currentToken.length} символов)
            </span>
          )}
        </div>
      </div>

      <div style={{ display: "flex", gap: 8, marginTop: 14, flexWrap: "wrap" }}>
        <button className="btn-primary" onClick={save}>💾 Сохранить</button>
        <button className="btn-cancel" onClick={clearToken}>🗑 Очистить</button>
        <button className="btn-cancel" disabled={testing} onClick={runTest}>
          {testing ? "⏳ Проверка…" : "🔌 Проверить подключение"}
        </button>
      </div>

      {test && (
        <div style={{
          marginTop: 14, padding: 12, borderRadius: 10,
          background: test.ok ? "#dcfce7" : "#fef2f2",
          color: test.ok ? "#166534" : "#991b1b",
          fontSize: 12, lineHeight: 1.6,
        }}>
          <div style={{ fontWeight: 700, marginBottom: 6 }}>
            {test.ok ? "✅ Запрос успешен" : "❌ Запрос провален"}
            <span style={{ color: "#6b7280", fontWeight: 400, marginLeft: 8 }}>
              {test.at}
            </span>
          </div>
          <div>Authorization ушёл: <b>{test.sentAuth ? "да" : "НЕТ"}</b></div>
          <div>URL: <code>{test.url}</code></div>

          {test.ok && (
            <>
              <div style={{ marginTop: 4 }}>
                Тело ответа:{" "}
                {test.dataIsNull
                  ? <b style={{ color: "#991b1b" }}>пустое (null)</b>
                  : <b>{JSON.stringify(test.dataKeys)}</b>}
              </div>
              <div style={{ marginTop: 4 }}>
                Формат <code>{"{counts:{total:…}}"}</code>:{" "}
                {test.looksLikeCounts
                  ? <b style={{ color: "#166534" }}>
                      ✅ total = {test.total}
                    </b>
                  : <b style={{ color: "#991b1b" }}>
                      ❌ нет поля counts.total
                    </b>}
              </div>
              <details style={{ marginTop: 6 }}>
                <summary style={{ cursor: "pointer" }}>
                  Полный ответ (sample)
                </summary>
                <pre style={{
                  background: "#fff", padding: 8, borderRadius: 6,
                  fontSize: 11, maxHeight: 260, overflow: "auto",
                  whiteSpace: "pre-wrap", wordBreak: "break-all",
                }}>{JSON.stringify(test.sample, null, 2).slice(0, 4000)}</pre>
              </details>
            </>
          )}

          {!test.ok && (
            <div style={{ marginTop: 6, fontFamily: "Consolas, monospace",
                          whiteSpace: "pre-wrap", wordBreak: "break-word" }}>
              {test.error}
            </div>
          )}
        </div>
      )}

      <div style={{
        marginTop: 16, padding: "12px 16px",
        background: "#eef2ff", borderRadius: 10,
        fontSize: 12, color: "#3730a3", lineHeight: 1.6,
      }}>
        <div style={{ fontWeight: 700, marginBottom: 6 }}>📍 Куда что ходит</div>
        <ul style={{ margin: 0, paddingLeft: 20 }}>
          <li><b>outreach</b> ({SenderApi.globalOutreachBase}):
            воркеры, кампании, каналы, счётчики сегментов.</li>
          <li><b>sender</b> ({SenderApi.globalSenderBase}):
            сегменты, шаблоны, импорт.</li>
          <li><b>локальный</b> ({SenderApi.base}):
            статус, запуск/стоп, журнал, прогресс, план, тест-письмо.</li>
        </ul>
      </div>

      <div style={{
        marginTop: 16, padding: "12px 16px",
        background: "#fef9c3", borderRadius: 10,
        fontSize: 12, color: "#854d0e", lineHeight: 1.5,
      }}>
        ℹ️ Локальный бекенд (<code>127.0.0.1:17873</code>) должен быть
        запущен, чтобы работали «🚀 Запуски», журнал, старт/стоп и тест.
        Сегменты/шаблоны/счётчики работают без него.
      </div>
    </div>
  );
}

const box = {
  marginTop: 16, padding: "14px 16px",
  background: "#f9fafb", borderRadius: 10,
  border: "1px solid #e5e7eb",
};